import React from "react";
import { AnchorBlock as AnchorBlockProps } from "../../types/optimizely/blocks";

const AnchorBlock = ({ enabled, id }: AnchorBlockProps) => {
  if (!enabled?.value || !id?.value) {
    return null;
  }

  return <div id={id.value} />;
};

export default AnchorBlock;
